import { fetcher } from "helpers/fetcher";

import { TGetParticipantInsuranceRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getEmployeeParticipantInsurance = async (userId: string) => {
  return await fetcher<TGetParticipantInsuranceRes, any>(
    ENDPOINT.USER.GET_EMPLOYEE_PARTICIPANT_INSURANCE,
    {
      headers: {
        [API_HEADER.VERSION]:
          ENDPOINT.USER.GET_EMPLOYEE_PARTICIPANT_INSURANCE.version,
        [API_HEADER.USER_ID]: userId,
      },
    }
  );
};

export const queryGetEmployeeParticipantInsurance = async (userId: string) => {
  return (await getEmployeeParticipantInsurance(userId)).data;
};

queryGetEmployeeParticipantInsurance._key = (userId: string) => [
  ENDPOINT.USER.GET_EMPLOYEE_PARTICIPANT_INSURANCE.url,
  userId,
];
